import { ExampleCalculationValue } from "globalConstants";
import { residualsCalculator } from "helpers/residuals/residualsCalculator";

export const waterfallCalculation = formValues => {
	const mapSplitProfileData = formValues => {
		const mapSplitInfo = (splitInfo: { [key: string]: any }[]) =>
			splitInfo.map(
				(
					info,
				): {
					agentId: string;
					partnerType: number;
					splitPercent: number;
				} => ({
					agentId: info.agent?.id,
					partnerType: info.agent?.partnerType,
					splitPercent: info.splitPercent,
				}),
			);

		return {
			scenario: formValues?.scenarioType?.value,
			totalRevenueShare: formValues?.totalRevenueShare,
			primaryInformation: mapSplitInfo([
				formValues?.primarySplitInformation,
			])[0],
			secondaryInformation: mapSplitInfo(
				formValues?.secondarySplitInformation,
			),
		};
	};

	return residualsCalculator(
		ExampleCalculationValue,
		mapSplitProfileData(formValues),
	);
};
